import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_UNSUB_BY_MARKETING_TYPE_241213 } from "@faire/retailer-settings/FE_UNSUB_BY_MARKETING_TYPE_241213";

export const useSettingEnableUnsubscribeByMarketingType = (): boolean =>
  useSetting(FE_UNSUB_BY_MARKETING_TYPE_241213);
